module.exports = __webpack_public_path__ + "static/fonts/roboto-v18-latin-500-285467176f7fe6bb6a9c6873b3dad2cc.woff2";